"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardFilters = void 0;
Object.defineProperty(exports, "ENVIRONMENT", {
  enumerable: true,
  get: function get() {
    return _environment.ENVIRONMENT;
  }
});
Object.defineProperty(exports, "FILTER_NAMES", {
  enumerable: true,
  get: function get() {
    return _filters.FILTER_NAMES;
  }
});
Object.defineProperty(exports, "FILTER_PRECEDENCE", {
  enumerable: true,
  get: function get() {
    return _filters.FILTER_PRECEDENCE;
  }
});
exports.useSavedFilters = exports.NetworkPerformance = exports.MerchantFulfillerPerformance = exports.FulfillerPerformance = void 0;

require("./index.css");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reducers = _interopRequireDefault(require("./reducers"));

var _Shell = _interopRequireDefault(require("./components/common/Shell"));

var _PerformanceNetwork = _interopRequireDefault(require("./components/PerformanceNetwork"));

var _PerformanceFulfiller = _interopRequireDefault(require("./components/PerformanceFulfiller"));

var _PerformanceMerchantFulfiller = _interopRequireDefault(require("./components/PerformanceMerchantFulfiller"));

var _Filters = _interopRequireDefault(require("./components/common/Filters"));

var _filters = require("./constants/filters");

var _environment = require("./constants/environment");

var _ErrorBoundary = _interopRequireDefault(require("./components/ErrorBoundary"));

var _useSavedSearch = _interopRequireDefault(require("./customHooks/useSavedSearch"));

var store = (0, _redux.createStore)(_reducers["default"]);

function WrapperComponent(WrappedComponent) {
  var HOC = function HOC(props) {
    return /*#__PURE__*/_react["default"].createElement(_ErrorBoundary["default"], null, /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
      store: store
    }, /*#__PURE__*/_react["default"].createElement(_Shell["default"], null, /*#__PURE__*/_react["default"].createElement(WrappedComponent, props))));
  };

  return HOC;
}

var NetworkPerformance = WrapperComponent(_PerformanceNetwork["default"]);
exports.NetworkPerformance = NetworkPerformance;
var FulfillerPerformance = WrapperComponent(_PerformanceFulfiller["default"]);
exports.FulfillerPerformance = FulfillerPerformance;
var MerchantFulfillerPerformance = WrapperComponent(_PerformanceMerchantFulfiller["default"]);
exports.MerchantFulfillerPerformance = MerchantFulfillerPerformance;
var DashboardFilters = WrapperComponent(_Filters["default"]);
exports.DashboardFilters = DashboardFilters;
var useSavedFilters = _useSavedSearch["default"];
exports.useSavedFilters = useSavedFilters;